import React from 'react';
import HeaderBlockEditor from './HeaderBlockEditor';
import HeroBlockEditor from './HeroBlockEditor';
import ImageBlockEditor from './ImageBlockEditor';
import ContentBlockEditor from './ContentBlockEditor';
import TracklistBlockEditor from './TracklistBlockEditor';
import MusicPlayerBlockEditor from './MusicPlayerBlockEditor';
import CTABlockEditor from './CTABlockEditor';
import SocialBlockEditor from './SocialBlockEditor';
import FooterBlockEditor from './FooterBlockEditor';
import CustomBlockEditor from './CustomBlockEditor';
import SpacerBlockEditor from './SpacerBlockEditor';
import DividerBlockEditor from './DividerBlockEditor';
import VideoBlockEditor from './VideoBlockEditor';
import './BlockEditorPanel.css';

const BlockEditorPanel = ({ selectedBlock, onUpdateBlock, onClose, isInline = false }) => {
  if (!selectedBlock) {
    return null; // Don't show anything if no block selected and inline mode
  }

  const renderEditor = () => {
    switch (selectedBlock.type) {
      case 'header':
        return <HeaderBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'hero':
        return <HeroBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'image':
        return <ImageBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'content':
        return <ContentBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'tracklist':
        return <TracklistBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'music-player':
        return <MusicPlayerBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'cta':
        return <CTABlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'social':
        return <SocialBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'footer':
        return <FooterBlockEditor block={selectedBlock} onUpdate=

{onUpdateBlock} />;
      case 'custom':
        return <CustomBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'spacer':
        return <SpacerBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'divider':
        return <DividerBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      case 'video':
        return <VideoBlockEditor block={selectedBlock} onUpdate={onUpdateBlock} />;
      default:
        return <div>Unknown block type: {selectedBlock.type}</div>;
    }
  };

  const getBlockLabel = (type) => {
    const labels = {
      header: 'Header',
      hero: 'Hero',
      image: 'Image',
      content: 'Content',
      tracklist: 'Tracklist',
      'music-player': 'Music Player',
      cta: 'Call to Action',
      social: 'Social Media',
      footer: 'Footer',
      custom: 'Custom HTML',
      spacer: 'Spacer',
      divider: 'Divider',
    };
    return labels[type] || type;
  };

  return (
    <div className={`block-editor-panel ${isInline ? 'inline' : ''}`}>
      {!isInline && (
        <div className="block-editor-header">
          <h3>{getBlockLabel(selectedBlock.type)} Settings</h3>
          <button className="close-btn" onClick={onClose} title="Close panel">
            ✕
          </button>
        </div>
      )}

      <div className="block-editor-content">
        {renderEditor()}
      </div>
    </div>
  );
};

export default BlockEditorPanel;
